import { TournamentState, utils } from '@ps/web-poker-tile-mappers';
import classNames from 'clsx';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { TIME } from '../../../../constants';
import type { Tournament } from '../../../../types/MTT';
import { formatMTTournamentAttr } from '../../../../utils/MTT/tournaments';

import styles from './InfoItemsContainer.scss';
import { INFO_ITEMS_BY_STATE } from './utils';

const TOURNAMENT_STATE_INTERVAL = [
  TournamentState.ANNOUNCED,
  TournamentState.REGISTERING,
  TournamentState.SEATING,
  TournamentState.LATE_REGISTRATION,
  TournamentState.RUNNING
];

export interface TournamentTimes {
  startTimeMs: number;
  regStartTimeMs?: number;
  closedTimeMs?: number;
  nowTimeMs: number;
  lateRegTs: number;
}

export interface InfoItemsContainerProps {
  tournament: Tournament;
  className?: string;
}

export interface InfoItemsProps extends InfoItemsContainerProps {
  timesData: TournamentTimes;
}

const InfoItemsContainer: React.FC<InfoItemsContainerProps> = ({ tournament, className = '' }) => {
  const { formattedState, whenStartInt, regEndInt, timeClosed, regStartInt } = tournament;
  const locale = useSelector(select.locale.getIntlLocale);
  const timeZone = useSelector(select.timeZone.getTimeZoneName);

  const [, setStartTime] = useState(Date.now());

  useEffect(() => {
    if (TOURNAMENT_STATE_INTERVAL.includes(formattedState)) {
      const interval = setInterval(() => {
        setStartTime(Date.now());
      }, TIME.SECOND * 20);
      return () => clearInterval(interval);
    }
  }, [formattedState]);

  const { nowTimestamp, lateRegTs, startTs, regOpensTs } = utils.mttUtils.getMttStartTime({
    timeZone,
    startTimestamp: whenStartInt,
    regStartTimestamp: regStartInt,
    lateRegTimestamp: regEndInt
  });

  const timesData: TournamentTimes = {
    startTimeMs: startTs * 1000,
    regStartTimeMs: regOpensTs * 1000,
    closedTimeMs: new Date(timeClosed).getTime(),
    nowTimeMs: nowTimestamp * 1000,
    lateRegTs
  };

  const formattedAttributes = formatMTTournamentAttr(
    tournament,
    locale,
    tournament.isPlayMoney,
    timeZone
  );

  const infoItemsProps = {
    tournament: {
      ...tournament,
      ...formattedAttributes
    },
    timesData
  };

  const infoItems = INFO_ITEMS_BY_STATE[tournament.formattedState] || INFO_ITEMS_BY_STATE.DEFAULT;

  return <div className={classNames(styles.container, className)}>{infoItems(infoItemsProps)}</div>;
};

export default InfoItemsContainer;
